import { NgModule } from '@angular/core';
import { SharepointComponent } from './sharepoint.component';
import { HelperModule } from 'dnp-helper';

@NgModule({
  declarations: [SharepointComponent],
  imports: [
    HelperModule
  ],
  exports: [SharepointComponent]
})
export class SharepointModule { }
